export const alterNateImage = require("./assests/marketplace-logo.png");

export const url = "https://zelo-api-gateway.azure-api.net/venapp/prod";
export const socketUrl = "https://socket.zelofinance.ai";
export const affiliatesUrl = "https://affiliates.efunder.ai";
export const monitorUrl = "https://app.zelofinance.ai";
export const isAllowSessionTime = 59 * 60 * 1000; // 59 mins
export const subscriptionKey = "978eac3c37f9407e9de2d285f2565a25";
export const VITE_APP_V3_SITE_KEY ="6Ld9xM0qAAAAABhw3QCDgfs2nkefT1vuCustxKsB"
export const VITE_APP_V2_SITE_KEY ="6LdUxM0qAAAAAPsKDlo3VKE7c9swYGEUkR4puzae"

export const  GTM_KEY = "GTM-KBNFSN8H";
 